import { render, staticRenderFns } from "./DetailProductService.vue?vue&type=template&id=51e5e323&"
import script from "./DetailProductService.vue?vue&type=script&lang=js&"
export * from "./DetailProductService.vue?vue&type=script&lang=js&"
import style0 from "./DetailProductService.vue?vue&type=style&index=0&id=51e5e323&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports